import * as constants from "./../constants";
import { StoreState } from "./../types";
import { buildQueryUrl, buildCsvDowloadUrl } from "../services/ApiClient";

export interface UpdateFilterAction {
  type: constants.UPDATE_FILTER;
  filterField: string;
  filterValue: string | string[];
}
export function setFilterValue(
  filterField: string,
  filterValue: string | string[],
): UpdateFilterAction {
  return {
    type: constants.UPDATE_FILTER,
    filterField,
    filterValue,
  };
}

export interface ResetStateAction {
  type: constants.RESET_STATE;
  newState: StoreState.Query;
}
export function resetState(newState: StoreState.Query): ResetStateAction {
  return {
    type: constants.RESET_STATE,
    newState,
  };
}

export interface AddToMultiFilterAction {
  type: constants.ADD_TO_MULTI_FILTER;
  filterField: string;
  filterValues: string[];
}
export function addToMultiFilterValue(
  filterField: string,
  filterValues: string[],
): AddToMultiFilterAction {
  return {
    type: constants.ADD_TO_MULTI_FILTER,
    filterField,
    filterValues,
  };
}

export interface RemoveFromMultiFilterAction {
  type: constants.REMOVE_FROM_MULTI_FILTER;
  filterField: string;
  filterValues: string[];
}
export function removeFromMultiFilterValue(
  filterField: string,
  filterValues: string[],
): RemoveFromMultiFilterAction {
  return {
    type: constants.REMOVE_FROM_MULTI_FILTER,
    filterField,
    filterValues,
  };
}

export interface UpdateSortOrderAction {
  type: constants.UPDATE_SORT;
  newSortField: string;
  newSortOrder: string;
}
export function setSortOrder(
  newSortField: string,
  newSortOrder: string,
): UpdateSortOrderAction {
  return {
    type: constants.UPDATE_SORT,
    newSortField,
    newSortOrder,
  };
}

export interface UpdateAggReportAction {
  type: constants.UPDATE_AGG_REPORT;
  aggReport: StoreState.Query["aggReport"];
}
export function setAggReport(
  aggReport: StoreState.Query["aggReport"],
): UpdateAggReportAction {
  return {
    type: constants.UPDATE_AGG_REPORT,
    aggReport,
  };
}

export interface AddDisplayFieldAction {
  type: constants.ADD_DISPLAY_FIELD;
  newDisplayFields: string[];
  clearAll?: boolean;
}
export function addDisplayField(
  newDisplayFields: string[],
  clearAll: boolean = false,
): AddDisplayFieldAction {
  return {
    type: constants.ADD_DISPLAY_FIELD,
    newDisplayFields,
    clearAll,
  };
}

export interface RemoveDisplayFieldAction {
  type: constants.REMOVE_DISPLAY_FIELD;
  removedFields: string;
}
export function removeDisplayField(removedFields: string): RemoveDisplayFieldAction {
  return {
    type: constants.REMOVE_DISPLAY_FIELD,
    removedFields,
  };
}

export interface UpdateApiUrlsAction {
  type: constants.UPDATE_API_URLS;
  apiJson: StoreState.Query["urls"]["apiJson"];
  csvDownload: StoreState.Query["urls"]["csvDownload"];
}
export function setApiUrls(
  query: StoreState.Query,
  apiPath: StoreState.Config["apiPath"],
): UpdateApiUrlsAction {
  return {
    type: constants.UPDATE_API_URLS,
    apiJson: buildQueryUrl(apiPath, query),
    csvDownload: buildCsvDowloadUrl(apiPath, query),
  };
}

export interface ReadBrowserLocationAction {
  type: constants.READ_BROWSER_LOCATION_INTO_STATE;
}
export function readBrowserLocation(): ReadBrowserLocationAction {
  return {
    type: constants.READ_BROWSER_LOCATION_INTO_STATE,
  };
}

export interface UpdateBrowserLocationAction {
  type: constants.UPDATE_BROWSER_LOCATION;
  locationSearchString: string;
}
export function setBrowserLocation(
  locationSearchString: string,
): UpdateBrowserLocationAction {
  return {
    type: constants.UPDATE_BROWSER_LOCATION,
    locationSearchString,
  };
}
